import { Eye, Download, FileText } from "lucide-react";
import { abs, formatSize } from "@/lib/api";

const BADGE = {
  "Faaliyet Raporu": "bg-navy-50 text-navy border-navy-100",
  "Finansal Tablolar": "bg-sky-50 text-sky-800 border-sky-100",
  "Bağımsız Denetim": "bg-indigo-50 text-indigo-800 border-indigo-100",
  "Değerleme": "bg-teal-50 text-teal-800 border-teal-100",
  "Birleşme": "bg-amber-50 text-amber-800 border-amber-100",
  "GK İlanı": "bg-red-50 text-brand-redDark border-red-100",
  "Gündem": "bg-orange-50 text-orange-800 border-orange-100",
  "Karar": "bg-emerald-50 text-emerald-800 border-emerald-100",
};

export const TypeBadge = ({ type }) => (
  <span className={`inline-flex items-center rounded border px-2 py-0.5 text-xs font-semibold ${BADGE[type] || "border-line bg-paper text-ink-soft"}`} data-testid="document-type-badge">
    {type}
  </span>
);

export const DocumentRow = ({ doc, showYear = false }) => {
  const isPdf = doc.ext === "PDF";
  const Icon = isPdf ? Eye : Download;
  return (
    <li className="group flex flex-col gap-3 px-4 py-4 transition-colors duration-150 hover:bg-paper sm:flex-row sm:items-center sm:gap-6 sm:px-6" data-testid={`document-row-${doc.slug}`}>
      <FileText className="hidden h-6 w-6 shrink-0 text-navy/60 sm:block" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold leading-snug text-ink" data-testid="document-title">{doc.title}</p>
        <div className="mt-1.5 flex flex-wrap items-center gap-2 text-sm text-ink-muted">
          <TypeBadge type={doc.doc_type} />
          {showYear && <span>{doc.year_label}</span>}
          <span data-testid="document-file-meta">{doc.ext} · {formatSize(doc.size)}</span>
        </div>
      </div>
      <a href={abs(doc.download_url)} target={isPdf ? "_blank" : undefined} rel={isPdf ? "noopener noreferrer" : undefined}
        className="inline-flex h-10 shrink-0 items-center justify-center gap-2 self-start rounded-md border border-navy px-4 text-sm font-semibold text-navy transition-colors duration-150 hover:bg-navy hover:text-white sm:self-center"
        aria-label={`${doc.title} — ${isPdf ? "görüntüle" : "indir"} (${doc.ext}, ${formatSize(doc.size)})`}
        data-testid={`document-download-btn-${doc.slug}`}>
        <Icon className="h-4 w-4" aria-hidden="true" /> {isPdf ? "Görüntüle" : "İndir"}
      </a>
    </li>
  );
};

export const DocumentList = ({ docs, showYear, testId }) => (
  <ul className="divide-y divide-line overflow-hidden rounded-md border border-line bg-white" data-testid={testId}>
    {docs.map((d) => <DocumentRow key={d.slug} doc={d} showYear={showYear} />)}
  </ul>
);
